/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ jobs: NonNullable<unknown> }} Import_Feed_LoadedInputs */

const cs_import_feed_loaded = /** @type {(inputs: Import_Feed_LoadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Načteno z feedu: ${i?.jobs} nabídek`)
};

const en_import_feed_loaded = /** @type {(inputs: Import_Feed_LoadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Loaded from feed: ${i?.jobs} offers`)
};

/**
* | output |
* | --- |
* | "Loaded from feed: {jobs} offers" |
*
* @param {Import_Feed_LoadedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_feed_loaded = /** @type {((inputs: Import_Feed_LoadedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Feed_LoadedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_feed_loaded(inputs)
	return cs_import_feed_loaded(inputs)
});